export default [
  {
    path: '/october_schedule/progress',
    name: 'october_schedule_progress',
    meta: {
      title: '我的进度'
    },
    component: () => import('views/october_schedule/progress')
  },
  {
    path: '/october_schedule/help',
    name: 'october_schedule_help',
    meta: {
      title: '“十月保贝”简介以及常见问题'
    },
    component: () => import('views/october_schedule/help')
  },
  {
    path: '/october_schedule/explain',
    name: 'october_schedule_explain',
    meta: {
      title: '十月保贝'
    },
    component: () => import('views/october_schedule/explain')
  }
]